<template>
    <div>
        <h4 class="mb-6">IPTV Providers</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addProviderPrompt = true">Add</vs-button>

        <vx-card>
            <vs-table id="table" ref="table" @selected="openProvider" pagination :max-items="itemsPerPage" search :data="tableData">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableData.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableData.length }} of {{ tableData.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="status">Status</vs-th>
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="max_connections">Max connections</vs-th>
                    <vs-th sort-key="allowed_connections">Allowed connections</vs-th>
                    <vs-th sort-key="playlist_url">Playlist URL</vs-th>
                    <vs-th>Online/Total sources</vs-th>
                    <vs-th sort-key="checker_workers">Checker Workers</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                            <vs-td :data="data[index].status" style="width: 130px">
                                <vs-chip color="danger" v-if="data[index].status === 0"></vs-chip>
                                <vs-chip color="warning" v-if="data[index].status === 1"></vs-chip>
                                <vs-chip color="success" v-if="data[index].status === 2"></vs-chip>
                            </vs-td>

                            <vs-td :data="data[index].name">
                                {{ data[index].name }}
                            </vs-td>

                            <vs-td :data="data[index].max_connections">
                                {{ data[index].max_connections }}
                            </vs-td>

                            <vs-td :data="data[index].allowed_connections">
                                {{ data[index].allowed_connections }}
                            </vs-td>

                            <vs-td :data="data[index].playlist_url">
                                {{ data[index].playlist_url }}
                            </vs-td>

                            <vs-td>
                                {{ data[index].online_sources }} / {{ data[index].total_sources }}
                            </vs-td>

                            <vs-td :data="data[index].checker_workers">
                                <vs-chip v-if="data[index].checker_workers.length === 0" color="danger">No checker</vs-chip>
                                <p style="float: left" class="mt-1">
                                    {{ data[index].checker_workers }}
                                </p>
                                <vx-tooltip class="ml-6" text="More than 1 checker!" style="float: left" v-if="data[index].checker_num > 1"><feather-icon style="color:#FF9F43" icon="AlertTriangleIcon" class="cursor-pointer"/></vx-tooltip>

                            </vs-td>

                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
        </vx-card>

        <vs-popup title="Add provider" :active.sync="addProviderPrompt">
            <div id="addProviderDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Max connections</p>
                <vs-input v-model="addObject['max_connections']" class="w-full"></vs-input>
                <p class="mt-6">Allowed connections</p>
                <vs-input v-model="addObject['allowed_connections']" class="w-full"></vs-input>
                <p class="mt-6">Playlist URL</p>
                <vs-input v-model="addObject['playlist_url']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addProvider">Add</vs-button>
            </div>
        </vs-popup>

    </div>
</template>
<script>

    export default {
        data() {
            return {

                itemsPerPage: 100,
                isMounted: false,

                providers: [],
                addProviderPrompt: false,

                addObject: {}

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#table',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/provider/')
                loadPromise.then(function(response) {
                    thisIns.providers = response.data
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })

                loadPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#table > .con-vs-loading')
                })
            },
            addProvider() {
                this.$vs.loading({
                    container: '#addProviderDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/provider/', {
                    name: this.addObject.name,
                    max_connections: Number(this.addObject.max_connections),
                    allowed_connections: Number(this.addObject.allowed_connections),
                    playlist_url: this.addObject.playlist_url
                })

                addPromise.then(function(response) {
                    thisIns.addProviderPrompt = false
                    thisIns.$printSuccess('Provider added')
                    thisIns.$vs.loading.close('#addProviderDiv > .con-vs-loading')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/provider/' + response.data.id)
                    })
                })

                addPromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                    thisIns.$vs.loading.close('#addProviderDiv > .con-vs-loading')
                })
            },
            openProvider(tr) {
                this.$router.push('/provider/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableData() {
                return this.providers
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        },
        beforeRouteLeave(to, from, next) {
            if (this.addProviderPrompt) {
                this.addProviderPrompt = false
                next(false)
            } else {
                next()
            }
        }

    }

</script>
